import { render, staticRenderFns } from "./NutritionBatchAddModal.vue?vue&type=template&id=1be10455&scoped=true"
import script from "./NutritionBatchAddModal.vue?vue&type=script&lang=js"
export * from "./NutritionBatchAddModal.vue?vue&type=script&lang=js"
import style0 from "./NutritionBatchAddModal.vue?vue&type=style&index=0&id=1be10455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be10455",
  null
  
)

export default component.exports